import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { getApprovalHistory } from '@/libs/fleet-api/services/prospect';
import { useQuery } from '@tanstack/react-query';
import { Table } from 'antd';
import { FC, useState } from 'react';

export type ApprovalHistoryModalState = null | {
	prospectId: string;
};

export type ApprovalHistoryModalProps = {
	modal: ApprovalHistoryModalState;
	onClose: () => void;
};

const ApprovalHistoryModal: FC<ApprovalHistoryModalProps> = ({
	modal,
	onClose,
}) => {
	const { data, isLoading } = useQuery({
		queryKey: ['getApprovalHistory', modal?.prospectId] as const,
		queryFn: ({ queryKey }) => {
			const [, id] = queryKey;
			return getApprovalHistory(id ?? '');
		},
		enabled: !!modal?.prospectId,
	});

	const approvalHistories = data?.data || [];

	return (
		<FleetModal
			open={Boolean(modal)}
			width={940}
			cancelText="BACK"
			buttonPosition="end"
			closable={false}
			okButtonProps={{
				hidden: true,
			}}
			onCancel={() => onClose?.()}
		>
			<FleetTitle>Approval History</FleetTitle>
			<Table
				dataSource={
					approvalHistories?.map((record, key) => {
						return { ...record, key };
					}) ?? []
				}
				columns={[
					{
						title: 'No',
						width: 1,
						align: 'center',
						dataIndex: 'no',
					},
					{
						title: 'Name',
						dataIndex: 'approvalBy',
					},
					{
						title: 'Date',
						dataIndex: 'approvalDate',
					},
					{
						title: 'Process',
						dataIndex: 'approvalProcess',
					},
					{
						title: 'Status',
						align: 'center',
						render: (_, record) => {
							return (
								<span
									className={`review-status ${record.approvalStatus.toLowerCase()}`}
								>
									{record.approvalStatus}
								</span>
							);
						},
					},
					{
						title: 'Approval Notes',
						render: (_, record) => {
							if (record.rejectCategory) {
								return (
									<span>
										{record.approvalNote}
										<br />
										{record.rejectCategory?.value}
									</span>
								);
							}
							return <span>{record.approvalNote}</span>;
						},
					},
				]}
				bordered
				pagination={false}
				loading={isLoading}
				style={{ marginBottom: 20 }}
			/>
		</FleetModal>
	);
};

export default ApprovalHistoryModal;

export const useApprovalHistoryModal = () => {
	return useState<ApprovalHistoryModalState>(null);
};
